/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentFootnote } from "../../../components/ComponentFootnote";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useTableData } from "../data/useTableData";
import { useAgGridTransformer } from "../transformers/useAgGridTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import { ComponentContextReadyState } from "@sa/rep-core";
import { Table } from "../../../components/Table";
import { debounceTime } from "rxjs/operators";
import { useExportSource } from "../hooks/useExportSource";
import "./custom-table.css";
import { useSubscriptionSource } from "../../../shared";

export const ComponentTable: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResultTable$.pipe<any>(debounceTime(300)));
  const source = useHookSubscribe(null, context.sources$);
  const loading = useHookSubscribe(null, context.loading$);
  useExportSource(source);
  useSubscriptionSource(source);

  const tableData = useTableData(olapResult);
  const agGridData = useAgGridTransformer(tableData);

  if (window["exportMode"]) {
    window["exportReady"] = agGridData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (loading) {
    return <ComponentPreloader />;
  }

  return (
    <>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <div className="custom-table-slide17-box">
        {agGridData ? <Table className="custom-table-slide17" {...agGridData} /> : <ComponentPreloader />}
      </div>
    </>
  );
};
